import { OffersCountTextComponent } from './offers-count-text.component';

import { runClientComponent } from '../../_common/client/client-component-runner';

runClientComponent({ offersCountText: OffersCountTextComponent });
